import React from 'react'

interface ErrorStateProps {
  onRetry: () => void
}

export const ProviderErrorState: React.FC<ErrorStateProps> = ({ onRetry }) => (
  <div className="rounded-none border border-red-100 bg-red-50 p-6">
    <p className="font-medium text-red-900">We couldn't load the editor.</p>
    <p className="text-sm text-red-900/80 mt-1">Please try again.</p>
    <button 
      onClick={onRetry} 
      className="mt-4 inline-flex items-center rounded-md bg-red-600 px-3 py-1.5 text-sm text-white cursor-pointer"
    >
      Retry
    </button>
  </div>
)
